// AddTemplate.jsx
import React, { useState } from 'react';
import styles from './AddTemplate.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import ToClose from '../../components/ToClose/ToClose';
import HeadingAndData from '../../components/HeadingAndData/HeadingAndData';
import HeadingAndDropDown from '../../components/HeadingAndDropDown/HeadingAndDropDown';
import SaveAndCancel from '../../components/SaveAndCancel/SaveAndCancel';
import { FaEnvelopeOpenText } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { closeModal } from '../../redux/slices/modalSlice';

const AddTemplate = () => {
  const dispatch = useDispatch();

  const [templateName, setTemplateName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [label, setLabel] = useState('');
  const [type, setType] = useState('');
  const [body, setBody] = useState('');

  const handleSave = () => {
    console.log({ templateName, email, subject, label, type, body });
  };

  const handleCancel = () => {
    setTemplateName('');
    setEmail('');
    setSubject('');
    setLabel('');
    setType('');
    setBody('');
  };

  return (
    <div className={styles.container}>
      <div className={styles.sectionBox}>
        <div className={styles.heading}>
          <HeadingAndIcon
            icon={<FaEnvelopeOpenText />}
            heading="Personal Details"
          />
          <ToClose onClose={() => dispatch(closeModal())} />
        </div>
        <div className={styles.data}>
          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Template Name"
              name="templateName"
              placeholder="Enter template name"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              required
            />
            <HeadingAndData
              label="Email Address"
              name="email"
              placeholder="Set email address where parents can send replies "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndData
              label="Subject"
              name="subject"
              placeholder="Enter subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              required
            />
          </div>

          <div className={styles.inputsRow}>
            <HeadingAndDropDown
              label="Label"
              name="label"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              required
              options={[
                { label: "Notice", value: "notice" },
                { label: "Reminder", value: "reminder" },
              ]}
              placeholder="Select label"
            />
            <HeadingAndDropDown
              label="Type"
              name="type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              required
              options={[
                { label: "Email", value: "email" },
                { label: "SMS", value: "sms" },
              ]}
              placeholder="Select type"
            />
          </div>

          <div className={styles.inputsRow}>
            <div className={styles.inputBlock}>
              <label htmlFor="body" className={styles.inputLabel}>
                Body *
              </label>
              <textarea
                id="body"
                name="body"
                className={styles.textarea}
                placeholder="Write body here"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                required
              ></textarea>
            </div>
          </div>
          <div className={styles.actionsRow}>
            <SaveAndCancel onSave={handleSave} onCancel={handleCancel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTemplate;
